import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import {
  TemplateLayoutTypeEnum,
  TemplateNodeTypeEnum,
  type TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import type React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
import { isUnderEmployeeCheckSection } from 'src/features/templateEdit/section/table/model'
import type { RootState } from 'src/state/store'
import { useAddTableSection } from './useAddTableSection'

interface OwnProps {
  isOpen: boolean
  node: TemplateNodeSchema | null
  position: 'top' | 'bottom'
  parentNode: TemplateNodeSchema | null
  addTemplateNode: (
    targetNode: TemplateNodeSchema | null,
    parentNode: TemplateNodeSchema | null,
    position: 'top' | 'bottom',
    addTemplateNodeType: TemplateNodeTypeEnum,
  ) => void
}

const AddTemplateModifyButtonGroup: React.FC<OwnProps> = (props: OwnProps) => {
  const { addTableSection, confirmDialog } = useAddTableSection()
  const { isFeatureAvailable } = useLimitedFeatureAvailability()
  const { layoutType } = useSelector(
    (state: RootState) => state.templatesState.editTemplate,
    shallowEqual,
  )
  const { templateNodes, activePageId, templatePages } = useSelector(
    (state: RootState) => state.templatesState.templatePages,
    shallowEqual,
  )
  if (!props.isOpen) return null

  const isGridLayout = layoutType === TemplateLayoutTypeEnum.Grid

  const handleAddTableSection = () => {
    addTableSection({
      templateNodes,
      targetNode: props.node,
      parentNode: props.parentNode,
      position: props.position,
      pageNodeIds:
        props.parentNode === null
          ? templatePages[activePageId]?.nodes
          : undefined,
    })
  }

  return (
    <>
      {confirmDialog}
      <Stack direction="row" spacing={1.25} sx={{ m: 1.25 }}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<AddOutlinedIcon />}
          onMouseDown={() => {
            props.addTemplateNode(
              props.node,
              props.parentNode,
              props.position,
              TemplateNodeTypeEnum.Question,
            )
          }}
          sx={{ flex: 1 }}
        >
          質問を追加
        </Button>
        {!isGridLayout && (
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<AddOutlinedIcon />}
            onMouseDown={() => {
              props.addTemplateNode(
                props.node,
                props.parentNode,
                props.position,
                TemplateNodeTypeEnum.Section,
              )
            }}
            sx={{ flex: 1 }}
          >
            セクションを追加
          </Button>
        )}
        {/* 従業員チェック配下の判定は重いので、Grid/プランの安価な判定を先に短絡評価する */}
        {!isGridLayout &&
          isFeatureAvailable('tableSection') &&
          !isUnderEmployeeCheckSection(props.parentNode, templateNodes) && (
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<AddOutlinedIcon />}
              onMouseDown={handleAddTableSection}
              aria-label={`${props.position === 'top' ? '上' : '下'}に表を追加`}
              sx={{ flex: 1 }}
            >
              表を追加
            </Button>
          )}
      </Stack>
    </>
  )
}

export default AddTemplateModifyButtonGroup
